import { getTemplateNavHeaderPrimaryStyles } from './NavHeaderPrimary.styles'
import {
  tryLoadDependencies,
  WebAwesomeComponent,
} from '@/components/webcomponents/Global/loadDependency'

const t = document.createElement('template')
t.innerHTML = `
<wa-details exportparts="base,header,summary,content,icon" class="mobile-primary-menu-dropdown">
  <slot></slot>
</wa-details>
`

class NavHeaderMobilePrimaryMenu extends HTMLElement {
  private waDetails: HTMLElement | null = null

  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Details])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderPrimaryStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))

    this.waDetails = shadow.querySelector('wa-details')
  }

  connectedCallback() {
    // Forward all attributes to wa-details
    if (this.waDetails) {
      for (const attr of this.attributes) {
        this.waDetails.setAttribute(attr.name, attr.value)
      }
    }
  }
}

customElements.define('ts-navheader-mobile-primary-menu', NavHeaderMobilePrimaryMenu)
export { NavHeaderMobilePrimaryMenu }
